import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";

import { roomLeave } from "../../../redux/actions/roomAction";

import io from "socket.io-client";
import "./VideoRoom.css";

import { FaVideoSlash, FaVideo, FaMicrophoneSlash, FaMicrophone } from "react-icons/fa";
import { ImPhoneHangUp } from "react-icons/im";

let socket;
const VideoRoom = () => {
	const dispatch = useDispatch();
	const history = useHistory();

	const roomState = useSelector(state => state.room);
	const userState = useSelector(state => state.user);

	const roomName = roomState.roomName;
	const username = userState.username;
	const roomId = roomState._id;

	// const room = window.location.pathname.substr(6);
	const userVideo = useRef();
	const userStream = useRef();
	const partnerVideo = useRef();
	const partnerID = useRef();
	const peerRef = useRef();
	const socketRef = useRef();
	const ENDPOINT = window.location.origin;

	useEffect(() => {
		if (roomId) {
			navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(stream => {
				userVideo.current.srcObject = stream;
				userStream.current = stream;

				socket = io.connect(ENDPOINT);
				socket.emit("join-video", { roomName, username });

				socket.on("room-maximum-capacity", () => history.push("/"));

				socket.on("user-receiver-id", receiverID => {
					partnerID.current = receiverID;
					callUser();
				});

				socket.on("user-caller-id", callerID => (partnerID.current = callerID));

				socket.on("offer", offer => handleOffer(offer));
				socket.on("answer", answer => handleAnswer(answer));
				socket.on("ice-candidate", iceCandidate => handleNewICECandidate(iceCandidate));
			});
		} else history.push("/");
		return () => {
			console.log("leaved");
			// Choose to use .enable instead of .stop because .stop leaves the last frame sent from video
			// userStream.current.getTracks().forEach(track => (track.enabled = false));
			if (roomState._id) {
				socket.disconnect();
				userStream.current.getTracks().forEach(track => track.stop());
				dispatch(roomLeave());
			}
		};
	}, [ENDPOINT]);

	function callUser() {
		peerRef.current = createPeer(true);
		userStream.current.getTracks().forEach(track => peerRef.current.addTrack(track, userStream.current));
	}

	function createPeer(isCalling) {
		const peer = new RTCPeerConnection({
			iceServers: [
				{
					urls: "stun:stun.stunprotocol.org",
				},
				{
					urls: "turn:numb.viagenie.ca",
					credential: "muazkh",
					username: "webrtc@live.com",
				},
			],
		});

		if (isCalling) peer.onnegotiationneeded = () => handleNegotiationNeededEvent();
		peer.onicecandidate = e => handleICECandidateEvent(e);
		peer.ontrack = e => handleTrackEvent(e);

		return peer;
	}

	function handleNegotiationNeededEvent() {
		peerRef.current
			.createOffer()
			.then(offer => {
				return peerRef.current.setLocalDescription(offer);
			})
			.then(() => {
				socket.emit("offer", {
					target: partnerID.current,
					sdp: peerRef.current.localDescription,
				});
			})
			.catch(e => console.log(e));
	}

	function handleOffer(offer) {
		peerRef.current = createPeer(false);
		const desc = new RTCSessionDescription(offer);
		peerRef.current
			.setRemoteDescription(desc)
			.then(() => {
				userStream.current.getTracks().forEach(track => peerRef.current.addTrack(track, userStream.current));
			})
			.then(() => {
				return peerRef.current.createAnswer();
			})
			.then(answer => {
				return peerRef.current.setLocalDescription(answer);
			})
			.then(() => {
				socket.emit("answer", {
					target: partnerID.current,
					sdp: peerRef.current.localDescription,
				});
			});
	}

	function handleAnswer(answer) {
		const desc = new RTCSessionDescription(answer);
		peerRef.current.setRemoteDescription(desc).catch(e => console.log(e));
	}

	function handleICECandidateEvent(e) {
		if (e.candidate) {
			socket.emit("ice-candidate", {
				target: partnerID.current,
				candidate: e.candidate,
			});
		}
	}

	function handleNewICECandidate(candidate) {
		const newCandidate = new RTCIceCandidate(candidate);
		peerRef.current.addIceCandidate(newCandidate).catch(e => console.log(e));
	}

	function handleTrackEvent(e) {
		partnerVideo.current.srcObject = e.streams[0];
	}

	const [videoClicked, setVideoClicked] = useState(true); // {true: enable, false: disable}
	const [soundClicked, setSoundClicked] = useState(true); // {true: enable, false: disable}

	// var mute = () => userStream.getTracks().forEach(track => (track.enabled = !track.enabled));
	var audioControl = trackState => (userStream.current.getTracks()[0].enabled = trackState);
	var videoControl = trackState => (userStream.current.getTracks()[1].enabled = trackState);

	// var mute = () => userStream.srcObject.getTracks().forEach(track => (track.enabled = !track.enabled));
	// var mute = () => userStream.current.srcObject.getTracks().forEach(track => (track.enabled = !track.enabled));

	return (
		<div className="video-page">
			<div className="options-hover">
				<div
					className={soundClicked ? "option-enable" : "option-disable"}
					onClick={() => {
						setSoundClicked(!soundClicked);
						audioControl(!soundClicked);
					}}
				>
					{soundClicked ? <FaMicrophone className="option-icon-enable" /> : <FaMicrophoneSlash className="option-icon-disable" />}
				</div>

				<div className="option-enable" onClick={() => history.push("/")}>
					<ImPhoneHangUp className="option-hangup" />
				</div>

				<div
					className={videoClicked ? "option-enable" : "option-disable"}
					onClick={() => {
						setVideoClicked(!videoClicked);
						videoControl(!videoClicked);
					}}
				>
					{videoClicked ? <FaVideo className="option-icon-enable" /> : <FaVideoSlash className="option-icon-disable" />}
				</div>
			</div>

			<div className="video-container">
				<video className="partner-video" autoPlay ref={partnerVideo} />
				<video muted className="user-video" autoPlay ref={userVideo} />
			</div>
		</div>
	);
};

export default VideoRoom;
